
const navigation = {
  home: 'Início',
  sugar: 'Açúcar',
  coffee: 'Café',
  logistics: 'Logística',
  news: 'Notícias',
  contact: 'Contato'
};

const hero = {
  title: 'Exportação de Commodities',
  subtitle: 'Açúcar e Café do Brasil para o Mundo',
  description: 'O Brasil é líder global na produção e exportação de açúcar e café. Este site apresenta um panorama completo sobre esses produtos, seus mercados, logística de exportação e muito mais.',
  exploreSugar: 'Explorar Açúcar',
  discoverCoffee: 'Descobrir Café'
};

const features = {
  title: 'Explore Nossas Seções',
  description: 'Descubra informações detalhadas sobre os processos, mercados e logística das principais commodities brasileiras',
  sugar: {
    title: 'Conheça o processo de exportação do açúcar',
    description: 'Do campo ao porto: entenda como o açúcar brasileiro chega aos mercados internacionais'
  },
  coffee: {
    title: 'Descubra os caminhos do café brasileiro',
    description: 'Tradição e qualidade que fazem do Brasil o maior exportador mundial de café'
  },
  logistics: {
    title: 'Entenda a logística e os navios de carga',
    description: 'A infraestrutura portuária e de transporte que viabiliza as exportações'
  },
  learnMore: 'Saiba Mais'
};

const stats = {
  title: 'Brasil em Números',
  description: 'Dados que demonstram a importância do Brasil no mercado mundial de commodities',
  sugarExport: 'Do açúcar produzido é exportado',
  coffeeWorld: 'Do café mundial vem do Brasil',
  mainPorts: 'Principais portos exportadores',
  countries: 'Países de destino'
};

const cta = {
  title: 'Mantenha-se Atualizado',
  description: 'Acompanhe as últimas tendências do mercado de commodities e novidades do setor',
  seeNews: 'Ver Notícias',
  contact: 'Entre em Contato'
};

// Sugar page translations
const sugar = {
  hero: {
    title: 'Açúcar Brasileiro',
    subtitle: 'Do Campo ao Porto'
  },
  types: {
    title: 'Tipos de Açúcar Exportado',
    vhp: {
      name: 'VHP (Very High Polarization)',
      description: 'Açúcar bruto com alta polarização, ideal para refino'
    },
    refined: {
      name: 'Refinado',
      description: 'Açúcar branco refinado, pronto para consumo'
    },
    crystal: {
      name: 'Cristal',
      description: 'Açúcar cristalizado, mais comum no mercado interno'
    }
  },
  regions: {
    title: 'Principais Regiões Produtoras',
    sp: {
      name: 'São Paulo',
      production: '55%',
      description: 'Maior região produtora do país'
    },
    mg: {
      name: 'Minas Gerais',
      production: '12%',
      description: 'Segunda maior região produtora'
    },
    go: {
      name: 'Goiás',
      production: '10%',
      description: 'Importante região do Centro-Oeste'
    }
  },
  process: {
    title: 'Processo de Exportação',
    step1: {
      title: 'Colheita da Cana-de-açúcar',
      description: 'Colheita mecanizada ou manual da cana'
    },
    step2: {
      title: 'Processamento em Usinas',
      description: 'Moagem e extração do caldo de cana'
    },
    step3: {
      title: 'Armazenamento e Transporte',
      description: 'Estocagem em silos e transporte rodoviário'
    },
    step4: {
      title: 'Embarque nos Portos',
      description: 'Carregamento em navios graneleiros'
    }
  },
  market: {
    title: 'Mercado Internacional',
    destinations: 'Principais Destinos',
    factors: {
      title: 'Fatores que Afetam os Preços',
      climate: {
        title: 'Condições Climáticas:',
        description: 'Secas ou chuvas excessivas afetam a produção'
      },
      oil: {
        title: 'Preço do Petróleo:',
        description: 'Influencia a produção de etanol como alternativa'
      },
      demand: {
        title: 'Demanda Mundial:',
        description: 'Crescimento populacional e mudanças no consumo'
      },
      exchange: {
        title: 'Taxa de Câmbio:',
        description: 'Variação do dólar impacta a competitividade'
      }
    }
  },
  curiosities: {
    title: 'Curiosidades do Açúcar Brasileiro',
    exported: 'Da produção brasileira é exportada',
    worldShare: 'Do açúcar mundial vem do Brasil',
    mills: 'Usinas em operação no país',
    hectares: 'Hectares de cana plantados',
    worldRank: 'Lugar mundial em produção',
    countries: 'Países importam nosso açúcar'
  }
};

// Coffee page translations
const coffee = {
  hero: {
    title: 'Café do Brasil',
    subtitle: 'Tradição e Qualidade Mundial'
  },
  history: {
    title: 'História e Importância Econômica',
    worldProduction: 'Produção Mundial',
    jobs: 'Empregos Gerados',
    exports: 'Exportações Anuais',
    importers: 'Países Importadores'
  },
  types: {
    title: 'Tipos de Café Exportados',
    arabica: {
      name: 'Arábica',
      percentage: '75%',
      description: 'Café de alta qualidade, sabor suave e aromático',
      regions: 'Minas Gerais, São Paulo, Espírito Santo'
    },
    robusta: {
      name: 'Robusta (Conilon)',
      percentage: '25%',
      description: 'Café mais resistente, sabor forte e maior teor de cafeína',
      regions: 'Espírito Santo, Rondônia, Bahia'
    }
  },
  states: {
    title: 'Estados Produtores',
    mg: {
      name: 'Minas Gerais',
      production: '54%',
      specialty: 'Arábica de montanha'
    },
    es: {
      name: 'Espírito Santo',
      production: '23%',
      specialty: 'Conilon e Arábica'
    },
    sp: {
      name: 'São Paulo',
      production: '9%',
      specialty: 'Arábica tradicional'
    },
    ba: {
      name: 'Bahia',
      production: '8%',
      specialty: 'Conilon e cafés especiais'
    }
  },
  process: {
    title: 'Processo de Exportação',
    step1: {
      title: 'Colheita',
      description: 'Manual (derriça) ou mecânica'
    },
    step2: {
      title: 'Secagem',
      description: 'Natural no terreiro ou artificial'
    },
    step3: {
      title: 'Beneficiamento',
      description: 'Descascamento e classificação'
    },
    step4: {
      title: 'Armazenagem',
      description: 'Em sacas ou contêineres'
    },
    step5: {
      title: 'Exportação',
      description: 'Embarque nos portos'
    }
  },
  market: {
    title: 'Destinos e Consumo Global',
    destinations: 'Principais Destinos',
    factors: {
      title: 'Fatores de Mercado',
      quotes: {
        title: 'Cotações Internacionais:',
        description: 'Bolsas de Nova York e Londres determinam preços'
      },
      climate: {
        title: 'Condições Climáticas:',
        description: 'Geadas e secas afetam significativamente os preços'
      },
      quality: {
        title: 'Qualidade:',
        description: 'Cafés especiais alcançam preços premium'
      },
      logistics: {
        title: 'Logística:',
        description: 'Custos de transporte influenciam competitividade'
      }
    }
  },
  trends: {
    title: 'Tendências do Mercado',
    specialty: {
      title: 'Cafés Especiais',
      description: 'Crescimento na demanda por cafés de origem única e métodos especiais de preparo'
    },
    certifications: {
      title: 'Certificações',
      description: 'Certificações orgânicas, Fair Trade e Rainforest Alliance'
    },
    sustainability: {
      title: 'Sustentabilidade',
      description: 'Práticas ambientalmente responsáveis e socialmente justas'
    }
  }
};

// Logistics page translations
const logistics = {
  hero: {
    title: 'Logística e Transporte',
    subtitle: 'A Infraestrutura por Trás da Exportação'
  },
  ships: {
    title: 'Tipos de Navios de Carga',
    bulk: {
      name: 'Graneleiros (Bulk Carriers)',
      description: 'Navios especializados no transporte de produtos a granel como açúcar',
      capacity: '60.000 - 200.000 toneladas'
    },
    containers: {
      name: 'Contêineres Secos',
      description: 'Transporte de café em sacas e produtos embalados',
      capacity: '1.000 - 20.000 TEU'
    },
    refrigerated: {
      name: 'Contêineres Refrigerados',
      description: 'Para produtos que necessitam controle de temperatura',
      capacity: '200 - 2.000 TEU'
    }
  },
  ports: {
    title: 'Principais Portos Exportadores',
    santos: {
      name: 'Porto de Santos (SP)',
      description: 'Maior porto da América Latina',
      products: 'Açúcar, Café, Soja',
      capacity: '4,8 milhões TEU/ano'
    },
    paranagua: {
      name: 'Porto de Paranaguá (PR)',
      description: 'Principal corredor de exportação do Sul',
      products: 'Açúcar, Soja, Milho',
      capacity: '1,2 milhões TEU/ano'
    },
    vitoria: {
      name: 'Porto de Vitória (ES)',
      description: 'Importante para minério e café',
      products: 'Café, Açúcar, Minério',
      capacity: '800 mil TEU/ano'
    },
    itaqui: {
      name: 'Porto de Itaqui (MA)',
      description: 'Gateway do Nordeste',
      products: 'Açúcar, Soja, Milho',
      capacity: '600 mil TEU/ano'
    }
  },
  storage: {
    title: 'Armazéns e Depósitos',
    silos: {
      name: 'Silos Graneleiros',
      description: 'Armazenamento vertical para açúcar a granel',
      capacity: '10.000 - 100.000 toneladas'
    },
    warehouses: {
      name: 'Depósitos Alfandegários',
      description: 'Armazéns para produtos aguardando exportação',
      capacity: '5.000 - 50.000 toneladas'
    },
    refrigerated: {
      name: 'Armazéns Refrigerados',
      description: 'Conservação de produtos sensíveis à temperatura',
      capacity: '1.000 - 20.000 toneladas'
    }
  },
  transport: {
    title: 'Transporte Interno',
    modes: 'Modais de Transporte',
    road: {
      name: 'Rodoviário',
      percentage: '70%',
      description: 'Principal modal para transporte interno'
    },
    rail: {
      name: 'Ferroviário',
      percentage: '25%',
      description: 'Crescente uso em algumas regiões'
    },
    waterway: {
      name: 'Hidroviário',
      percentage: '5%',
      description: 'Utilizado em regiões específicas'
    },
    characteristics: {
      title: 'Características do Transporte',
      distances: {
        title: 'Distâncias Médias',
        farm: 'Fazenda → Armazém: 50-200 km',
        warehouse: 'Armazém → Porto: 200-800 km',
        time: 'Tempo médio: 2-5 dias'
      },
      costs: {
        title: 'Custos Logísticos',
        percent: 'Representam 15-25% do preço final',
        fuel: 'Combustível: maior componente',
        tolls: 'Pedágios e taxas portuárias'
      },
      seasonality: {
        title: 'Sazonalidade',
        peak: 'Pico na colheita (mai-set)',
        demand: 'Maior demanda por transporte',
        increase: 'Aumento nos fretes'
      }
    }
  },
  challenges: {
    title: 'Desafios e Oportunidades',
    infrastructure: {
      title: 'Infraestrutura Portuária',
      description: 'Necessidade de modernização e ampliação da capacidade'
    },
    costs: {
      title: 'Custos Logísticos',
      description: 'Redução dos custos de transporte e armazenagem'
    },
    sustainability: {
      title: 'Sustentabilidade',
      description: 'Implementação de práticas ambientalmente responsáveis'
    },
    digitalization: {
      title: 'Digitalização',
      description: 'Automação e controle digital dos processos'
    }
  },
  numbers: {
    title: 'Números da Logística',
    tonnage: 'Toneladas movimentadas/ano',
    ports: 'Portos organizados',
    terminals: 'Terminais privativos',
    gdp: 'Custo logístico do PIB'
  }
};

// News page translations
const news = {
  hero: {
    title: 'Notícias e Tendências',
    subtitle: 'O Que Está Acontecendo no Mercado de Exportação?'
  },
  market: {
    title: 'Cotações em Tempo Real'
  },
  tabs: {
    recent: 'Notícias Recentes',
    analysis: 'Análises',
    forecasts: 'Previsões'
  },
  analysis: {
    title: 'Análise de Mercado',
    positive: {
      title: 'Fatores Positivos',
      climate: 'Clima favorável para próxima safra',
      demand: 'Demanda internacional crescente',
      infrastructure: 'Melhorias na infraestrutura logística'
    },
    challenges: {
      title: 'Desafios',
      exchange: 'Volatilidade do câmbio',
      competition: 'Competição internacional',
      costs: 'Custos logísticos elevados'
    }
  },
  newsletter: {
    title: 'Mantenha-se Informado',
    description: 'Receba atualizações semanais sobre o mercado de commodities diretamente no seu e-mail',
    placeholder: 'Seu e-mail',
    subscribe: 'Inscrever-se'
  }
};

// Contact page translations
const contact = {
  hero: {
    title: 'Sobre o Projeto',
    subtitle: 'Conheça nossa equipe e entre em contato conosco'
  },
  about: {
    title: 'Quem Somos'
  },
  objectives: {
    title: 'Nossos Objetivos',
    educational: {
      title: 'Educacional',
      description: 'Educar sobre os processos de produção e exportação das principais commodities brasileiras'
    },
    informative: {
      title: 'Informativo',
      description: 'Fornecer dados atualizados sobre mercados, preços e tendências do setor'
    },
    connective: {
      title: 'Conectivo',
      description: 'Conectar diferentes públicos interessados no agronegócio brasileiro'
    }
  },
  team: {
    title: 'Nossa Equipe'
  },
  sources: {
    title: 'Fontes de Dados',
    description: 'Utilizamos exclusivamente dados oficiais de instituições reconhecidas para garantir a precisão e confiabilidade das informações apresentadas.'
  },
  form: {
    title: 'Entre em Contato',
    subtitle: 'Tem dúvidas, sugestões ou gostaria de contribuir? Fale conosco!',
    name: 'Nome Completo',
    email: 'E-mail',
    subject: 'Assunto',
    message: 'Mensagem',
    send: 'Enviar Mensagem',
    sending: 'Enviando...',
    success: 'Mensagem enviada com sucesso! Entraremos em contato em breve.',
    error: 'Erro ao enviar mensagem. Tente novamente.',
    selectSubject: 'Selecione um assunto',
    subjects: {
      doubt: 'Dúvida sobre dados',
      suggestion: 'Sugestão de melhoria',
      contribution: 'Contribuição com dados',
      partnership: 'Proposta de parceria',
      press: 'Imprensa',
      other: 'Outro'
    },
    placeholder: {
      name: 'Seu nome completo',
      email: 'seu@email.com',
      message: 'Descreva sua mensagem (máximo 500 caracteres)'
    },
    charRemaining: 'caracteres restantes'
  },
  social: {
    title: 'Nos Acompanhe',
    description: 'Siga-nos nas redes sociais para receber as últimas atualizações sobre o mercado de commodities'
  }
};

export default {
  navigation,
  hero,
  features,
  stats,
  cta,
  sugar,
  coffee,
  logistics,
  news,
  contact
};
